import { sprite, spriteUrl } from "./sprite";

/**
 * Runtime skin assets that CSS cannot express: pixel cursors and the
 * tread-plate page background. They are generated from sprites so they share
 * the palette, then exposed as CSS custom properties used by index.css.
 */

const legend = { w: "white", m: "maroon900", M: "maroon", p: "#120009" } as const;

const ARROW = sprite(
  `
  k..........
  kk.........
  kwk........
  kwwk.......
  kwwwk......
  kwwwwk.....
  kwwwwwk....
  kwwwwwwk...
  kwwwwwwwk..
  kwwwwwwwwk.
  kwwwwwkkkkk
  kwwkwwk....
  kwk.kwwk...
  kk..kwwk...
  k....kwwk..
  .....kwwk..
  ......kk...
  `,
  legend,
  "cursor-arrow",
);

const HAND = sprite(
  `
  ....kk.......
  ...kwwk......
  ...kwwk......
  ...kwwk......
  ...kwwkkk....
  ...kwwkwwkk..
  .kkkwwkwwkwkk
  kwwkwwwwwwkwk
  kwwkwwwwwwwwk
  .kwwwwwwwwwwk
  ..kwwwwwwwwwk
  ..kwwwwwwwwk.
  ...kwwwwwwwk.
  ...kwwwwwwk..
  ....kwwwwwk..
  ....kkkkkkk..
  `,
  legend,
  "cursor-hand",
);

const TREAD = sprite(
  `
  ................
  ....pM..........
  ...pMm..........
  ..pMm...........
  ..Mm............
  ................
  ................
  ................
  ................
  ..........Mp....
  ..........mMp...
  ...........mMp..
  ............mM..
  ................
  ................
  ................
  `,
  legend,
  "tread-plate",
);

export function applySkin() {
  const root = document.documentElement.style;
  root.setProperty("--cursor-default", `url(${spriteUrl(ARROW, {}, 2)}) 0 0, auto`);
  root.setProperty("--cursor-pointer", `url(${spriteUrl(HAND, {}, 2)}) 9 0, pointer`);
  root.setProperty("--bg-tile", `url(${spriteUrl(TREAD, {}, 2)})`);
}

export const SKIN_SPRITES = { ARROW, HAND, TREAD };
